import React from "react";
import AppleSignin from "react-apple-signin-auth";
import { useGoogleLogin, TokenResponse } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import AppelIcon from "../../../assets/auth-icons/appel-Icon.svg";
import GoogleIcon from "../../../assets/auth-icons/google-icon.svg";
import { verifyApple, verifyGoogle } from "../../../store/actions/actions";


interface SocialAuthButtonsProps {
  onLoginSuccess: () => void;
}

const SocialAuthButtons: React.FC<SocialAuthButtonsProps> = ({ onLoginSuccess }) => {
  const dispatch = useDispatch();

  const googleLogin: any = useGoogleLogin({
    overrideScope: true,
    scope: "openid profile email",
    onSuccess: (tokenResponse: TokenResponse) => {
      onLoginSuccess();
      dispatch(verifyGoogle(`${tokenResponse.access_token}`));
    },
    onError: () => console.log("Google login failed"),
  });

  return (
    <div className="social-media-wrapper">
      <AppleSignin
        authOptions={{
          clientId: "fioeat.frenchinnov.fr",
          scope: "email",
          redirectURI: "https://fioeat.com",
          state: "state",
          nonce: "nonce",
          usePopup: true,
        }}
        uiType="dark"
        className="apple-auth-btn"
        noDefaultStyle={false}
        buttonExtraChildren="Continue with Apple"
        onSuccess={(response: any) => {
          onLoginSuccess();
          dispatch(verifyApple(response?.authorization?.id_token));
        }}
        onError={(error: any) => console.error(error)}
        skipScript={false}
        render={(props: any) => (
          <button {...props} className="btn-form social-btn">
            <img src={AppelIcon} alt="Apple" /> Continuer avec Apple
          </button>
        )}
      />

      <button className="btn-form social-btn" onClick={googleLogin}>
        <img src={GoogleIcon} alt="Google" /> Continuer avec Google
      </button>
    </div>
  );
};

export default SocialAuthButtons;
